import { JSX } from 'react';
import { EmptyDataIconWithTooltip } from '../elements/EmptyDataIcon';
import { TimeScaleBarComponent } from '../elements/TimeScaleBarComponent';
import { DurationAndItems } from './types';
import { Activities, ActivityConfig, INACTIVE_COLOR } from '../../enums/Activities';
import { MAXIMUM_WEEKLY_DRIVING_MINUTES } from '../../legalDrivingRestrictions';

interface RemainingDrivingWeekCellProps {
    value?: DurationAndItems;
}

export const RemainingDrivingWeekCell = (props: RemainingDrivingWeekCellProps): JSX.Element => {
    const color = ActivityConfig[Activities.DRIVING].color;
    const { value } = props;

    if (!value || value.duration === undefined) {
        return <EmptyDataIconWithTooltip />;
    }

    const percentageOfTime = (100 * value.duration) / MAXIMUM_WEEKLY_DRIVING_MINUTES;

    const progressParts = [
        {
            percentage: 100 - percentageOfTime,
            color: INACTIVE_COLOR,
            tooltipId: 'intl-msg:timed.driving-time-table.maximum56Hours',
        },
        {
            percentage: percentageOfTime,
            color,
            tooltipId: 'intl-msg:timed.driving-time-table.remainingWeekDrivingTime',
        },
    ];

    return (
        <TimeScaleBarComponent
            numberValue={value.duration}
            progressParts={progressParts}
            infringementLevel={value?.level}
            textColor={color}
        />
    );
};
